import React from "react";

interface LoadingModalProps {
  onClose: () => void;
}

const LoadingModal: React.FC<LoadingModalProps> = ({ onClose }) => {

  const handleBackdropClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg w-11/12 max-w-3xl h-5/6 p-6 shadow-lg relative overflow-y-auto">
        <div className="flex justify-center items-center h-full">
          <div 
            className="loader animate-spin rounded-full h-12 w-12 border-t-4 border-b-4"
            style={{ borderColor: "#5BC0BE" }} 
          />
        </div>
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-2xl font-bold"
          onClick={onClose}
        >
          &times;
        </button>
      </div>
    </div>
  );
}

export default LoadingModal;